import { render, staticRenderFns } from "./sample.vue?vue&type=template&id=034f9b0b"
import script from "./sample.vue?vue&type=script&lang=ts"
export * from "./sample.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports